import { isSemrush } from '/src/utils/semrush';

import { AppLink } from './AppLink';

const SUPPORT_HOSTNAMES = new Set(['support.crazyegg.com', 'semrush-support.crazyegg.com']);

function toSupportPath(href) {
  if (typeof href !== 'string' || !href) {
    return null;
  }

  if (href.startsWith('/')) {
    return href;
  }

  try {
    const url = new URL(href);

    if (!SUPPORT_HOSTNAMES.has(url.hostname)) {
      return null;
    }

    return `/help${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function SupportLink({ href, children, ...rest }) {
  const supportPath = toSupportPath(href);
  const externalProps = {
    target: '_blank',
    rel: 'noopener noreferrer',
  };

  if (isSemrush && supportPath) {
    return (
      <AppLink to={supportPath} {...rest} {...externalProps}>
        {children}
      </AppLink>
    );
  }

  return (
    <a href={href} {...rest} {...externalProps}>
      {children}
    </a>
  );
}
